<template>
  <v-alert color="primary" border="left" elevation="2" colored-border>
    <div class="d-flex justify-space-between align-baseline">
      <div>
        <v-icon left color="primary" class="mx-2"
          >mdi-account-tie-outline</v-icon
        >
        <span class="pt-1"
          >Admin controls : pending "{{
            proposal.status.replace("_REQUEST", "")
          }}" request (verify all the informations before approval)</span
        >
        <!--        <v-chip-->
        <!--          small-->
        <!--          class="ml-4"-->
        <!--          outlined-->
        <!--          :color="visitedTabs.length === 4 ? 'success' : 'warning'"-->
        <!--        >-->
        <!--          <v-icon left-->
        <!--            >mdi-checkbox-multiple-{{-->
        <!--              visitedTabs.length === 4 ? "marked" : "blank"-->
        <!--            }}-circle-outline</v-icon-->
        <!--          >-->
        <!--          {{ visitedTabs.length }}/3 tabs visited-->
        <!--        </v-chip>-->
      </div>
      <div class="text-right">
        <v-dialog
          :width="$vuetify.breakpoint.mdAndUp ? '25%' : '100%'"
          v-model="rejectDialog"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="error" text class="mx-1" v-on="on"
              ><v-icon left>mdi-clipboard-text-off-outline</v-icon>Reject</v-btn
            >
          </template>
          <v-card>
            <v-card-title>Confirmation</v-card-title>
            <v-card-subtitle class="pt-2"
              >Are you sure you want to reject this request ?</v-card-subtitle
            >
            <v-card-text class="pb-0 pt-2">
              <v-textarea
                v-model="rejectionMessage"
                outlined
                placeholder="Rejection reason/details..."
              ></v-textarea>
            </v-card-text>
            <v-card-actions class="pb-5 pt-0 justify-center">
              <v-btn text class="mx-1" @click="rejectDialog = false"
                >Cancel</v-btn
              >
              <v-btn
                outlined
                color="success"
                class="mx-1"
                @click="submitRejection"
                >Confirm</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          :width="$vuetify.breakpoint.mdAndUp ? '20%' : '100%'"
          v-model="validateDialog"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="success" outlined class="mx-1" v-on="on"
              ><v-icon left>mdi-check-all</v-icon>Approve request</v-btn
            >
          </template>
          <v-card class="text-center justify-center">
            <v-card-title class="justify-center ">Confirmation</v-card-title>
            <v-card-subtitle class="pt-2"
              >Are you sure you want to approve this request ?</v-card-subtitle
            >
            <v-card-actions class="pb-5 pt-0 justify-center">
              <v-btn text class="mx-1" @click="validateDialog = false"
                >Cancel</v-btn
              >
              <v-btn
                color="success"
                outlined
                class="mx-1"
                @click="submitValidate"
                >Confirm</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: "ValidationControls",
  props: {
    proposal: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      validateDialog: false,
      rejectDialog: false,
      visitedTabs: [],
      rejectionMessage: ""
    }
  },
  computed: {},
  methods: {
    submitValidate() {
      this.validateDialog = false
      this.$emit("validate")
    },

    submitRejection() {
      this.rejectDialog = false
      this.$emit("reject", this.rejectionMessage)
    }
  }
}
</script>

<style scoped></style>
